// CentraJob Color Palette - Clean, Minimal UI Theme

export const colors = {
  primary: {
    main: '#513cf1',
    light: '#7b6ae8',
    dark: '#4531ca',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#6B7280',
    light: '#9CA3AF',
    dark: '#4B5563',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#DC2626',
    light: '#FEE2E2',
    dark: '#B91C1C',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#D97706',
    light: '#FEF3C7',
    dark: '#B45309',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#059669',
    light: '#D1FAE5',
    dark: '#047857',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#3B82F6',
    light: '#DBEAFE',
    dark: '#2563EB',
    contrastText: '#FFFFFF',
  },
  grey: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#E5E5E5',
    300: '#D4D4D4',
    400: '#A3A3A3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
  },
  background: {
    default: '#FAFAFA',
    paper: '#FFFFFF',
    toolbar: '#FFFFFF',
    surface: '#FAFAFA',
    light: '#F5F5F5',
  },
  text: {
    primary: '#171717',
    secondary: '#525252',
    disabled: '#A3A3A3',
    hint: '#737373',
  },
  common: {
    white: '#FFFFFF',
    black: '#000000',
    transparent: 'transparent',
  },
  divider: '#EDEFFE',
} as const;

export const brand = {
  shade1: '#F0F9FF',
  shade2: '#E0F2FE',
  shade3: '#DBEAFE',
  shade4: '#BFDBFE',
  shade5: '#93C5FD',
  shade6: '#60A5FA',
  shade7: '#3B82F6',
  shade8: '#2563EB',
  shade9: '#1D4ED8',
  shade10: '#1E40AF',
  shade11: '#1E3A8A',
  shade12: '#172554',
} as const;

export const error = {
  shade1: '#FFFBFA',
  shade2: '#FEF3F2',
  shade3: '#FEE4E2',
  shade4: '#FECDCA',
  shade5: '#FDA29B',
  shade6: '#F97066',
  shade7: '#F04438',
  shade8: '#D92D20',
  shade9: '#B42318',
  shade10: '#912018',
  shade11: '#7A271A',
  shade12: '#55160C',
} as const;

export const warning = {
  shade1: '#FFFCF5',
  shade2: '#FEF3F2',
  shade3: '#FEF0C7',
  shade4: '#FEDF89',
  shade5: '#FEC84B',
  shade6: '#FDB022',
  shade7: '#F79009',
  shade8: '#DC6803',
  shade9: '#B54708',
  shade10: '#93370D',
  shade11: '#7A2E0E',
  shade12: '#4E1D09',
} as const;

export const success = {
  shade1: '#F6FEF9',
  shade2: '#ECFDF3',
  shade3: '#DCFAE6',
  shade4: '#ABEFC6',
  shade5: '#75E0A7',
  shade6: '#47CD89',
  shade7: '#17B26A',
  shade8: '#079455',
  shade9: '#067647',
  shade10: '#085D3A',
  shade11: '#074D31',
  shade12: '#053321',
} as const;

export const greyLightMode = {
  shade1: '#FDFDFD',
  shade2: '#FAFAFA',
  shade3: '#F5F5F5',
  shade4: '#E9EAEB',
  shade5: '#D5D7DA',
  shade6: '#A4A7AE',
  shade7: '#717680',
  shade8: '#535862',
  shade9: '#414651',
  shade10: '#252B37',
  shade11: '#181D27',
  shade12: '#0A0D12',
  shade13: '#D9D9D9',
  shade14: '#D1D0CE',
} as const;

export const white = {
  primary: '#FFFFFF',
  shade1: '#F7F6F3',
  shade2: '#E4E8ED',
  shade3: '#F8F6EF',
  shade4: '#F9F9F9',
  shade5: '#F8F9FC',
  shade6: '#E4E7EC',
} as const;

export const black = {
  primary: '#000000',
  shade1: '#161616',
  shade2: '#101828',
} as const;

export const blue = {
  primary: '#5031E8',
  shade1: '#D5D9EB',
  shade13: '#363F72',
} as const;

export const purple = {
  shade1: '#faf5ff',
  shade2: '#f5f3ff',
  shade3: '#ede9fe',
  shade4: '#ddd6fe',
  shade5: '#c4b5fd',
  shade6: '#a78bfa',
  shade7: '#8b5cf6',
  shade8: '#7c3aed',
  shade9: '#6d28d9',
  shade10: '#5b21b6',
  shade11: '#4c1d95',
  shade12: '#3b0764',
} as const;

export const amber = {
  shade1: '#fffbeb',
  shade2: '#fef3c7',
  shade3: '#fde68a',
  shade4: '#fcd34d',
  shade5: '#fbbf24',
  shade6: '#f59e0b',
  shade7: '#d97706',
  shade8: '#b45309',
  shade9: '#92400e',
  shade10: '#78350f',
} as const;

export const green = {
  shade1: '#f0fdf4',
  shade2: '#dcfce7',
  shade3: '#bbf7d0',
  shade4: '#86efac',
  shade5: '#4ade80',
  shade6: '#22c55e',
  shade7: '#16a34a',
  shade8: '#15803d',
  shade9: '#166534',
  shade10: '#14532d',
} as const;

export const red = {
  shade1: '#fef2f2',
  shade2: '#fee2e2',
  shade3: '#fecaca',
  shade4: '#fca5a5',
  shade5: '#f87171',
  shade6: '#ef4444',
  shade7: '#dc2626',
  shade8: '#b91c1c',
  shade9: '#991b1b',
  shade10: '#7f1d1d',
} as const;

export const indigo = {
  shade1: '#eef2ff',
  shade2: '#e0e7ff',
  shade3: '#c7d2fe',
  shade4: '#a5b4fc',
  shade5: '#818cf8',
  shade6: '#6366f1',
  shade7: '#4f46e5',
  shade8: '#4338ca',
  shade9: '#3730a3',
  shade10: '#312e81',
} as const;

export const shadowColor = 'rgba(10, 13, 18, 0.05)';

export const cj = {
  backgroundPrimary: '#FFFFFF',
  backgroundSecondary: '#FAFAFA',
  backgroundTertiary: '#F5F5F5',
  textPrimary: '#171717',
  textSecondary: '#525252',
  textTertiary: '#737373',
  textDisabled: '#A3A3A3',
  border: '#E5E5E5',
  divider: '#D4D4D4',
  brandPrimary: '#3B82F6',
  brandLight: '#DBEAFE',
  errorBackground: '#FEE2E2',
  warningBackground: '#FEF3C7',
  successBackground: '#D1FAE5',
  infoBackground: '#DBEAFE',
} as const;
